import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import CONSTANT from '../../utils/constants';
import { clientMessage, staticPath } from '../../utils/common';
import OverlayWrap from '../OverlayWrap';
import ProcessLoader from '../ProcessLoader';

class Overlay extends Component {
  constructor(props) {
    super(props);
    this.processingLabel = clientMessage(CONSTANT.PROCESSING.toLowerCase(), this.props.cache).label;
    this.retryLabel = clientMessage(CONSTANT.RETRY.toLowerCase(), this.props.cache).label;
  }

  render({ overlayValue, onOverlayValueChange, retryMessage, customOverlayData }) {
    return (
      <div id="checkout-overlay-box">
        {overlayValue && (
          <OverlayWrap>
            <div>
              {/* <-- custom processing --> */}
              {overlayValue === CONSTANT.CUSTOM_PROCESSING &&
                customOverlayData &&
                customOverlayData.heading &&
                (customOverlayData.desc ||
                  (customOverlayData.handlerText && customOverlayData.handler)) && (
                  <div class={`ptm-process-wrap`}>
                    <div>
                      <span class={`ptm-process-heading ptm-body-color`}>
                        {customOverlayData.heading}
                      </span>
                      <ProcessLoader />
                    </div>
                    {customOverlayData.desc && (
                      <p class={`ptm-overlay-txt ptm-body-color`}>{customOverlayData.desc}</p>
                    )}
                    {customOverlayData.handlerText && (
                      <p
                        class={`ptm-overlay-txt ptm-primary ptm-semibold ptm-body-color`}
                        onClick={customOverlayData.handler}
                      >
                        {customOverlayData.handlerText}
                      </p>
                    )}
                  </div>
                )}
              {/* <-- processing --> */}
              {overlayValue === CONSTANT.PROCESSING && (
                <div class={`ptm-process-wrap`}>
                  <div>
                    <span class={`ptm-process-heading ptm-body-color`}>
                      {this.processingLabel.heading}
                    </span>
                    <ProcessLoader />
                  </div>
                  <p class={`ptm-overlay-txt ptm-body-color`}>{this.processingLabel.info}</p>
                </div>
              )}
              {/* <-- payment failed --> */}
              {overlayValue === CONSTANT.RETRY && (
                <div class={`pay-failed`}>
                  <h4 class={`ptm-pay-heading ptm-red-bg ptm-body-color`}>
                    {this.retryLabel.paymentFailed}
                    <img
                      className="ptm-right ptm-margin0"
                      src={`${staticPath()}/assets/images/ic-failed.svg`}
                      alt=""
                    />
                  </h4>
                  <div class={`ptm-retry-box`}>
                    <span class={`ptm-sugg-txt ptm-txtcolor ptm-body-color`}>
                      {retryMessage || this.retryLabel.info}
                    </span>
                    <button
                      class={`ptm-retry-btn ptm-right border-button ptm-custom-btn`}
                      onClick={() => onOverlayValueChange('')}
                      type="button"
                    >
                      Retry
                    </button>
                  </div>
                </div>
              )}
            </div>
          </OverlayWrap>
        )}
      </div>
    );
  }
}

export default connect(
  'overlayValue, retryMessage, customOverlayData, cache',
  onChange
)(Overlay);



// WEBPACK FOOTER //
// ./components/overlaybox/index.js